<template>
	<section>
        <div class="form-pengiriman">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active p-1" id="profil-tab" data-toggle="tab" href="#profil" role="tab" aria-controls="profil" aria-selected="true">Profil</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link p-1" id="alamat-tab" data-toggle="tab" href="#alamat" role="tab" aria-controls="alamat" aria-selected="false">Alamat</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link p-1" id="password-tab" data-toggle="tab" href="#password" role="tab" aria-controls="password" aria-selected="false">Ubah Kata Sandi</a>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="profil" role="tabpanel" aria-labelledby="profil-tab" >
                    <ValidationObserver ref="profil" tag="form" onsubmit="return false;">
                        <form @submit.prevent="update_profile()">
                            <div class="mx-auto mt-4 col-lg-6">
                                <div class="text-center mb-4">
                                    <div v-if="me.photo_profile != null" class="text-center profile-avatar">
                                        <img :src="me.photo_profile" class="img-fluid rounded mt-1 mr-1 pointer"><br>
                                        <div class="edit-avatar">
                                            <button 
                                                @click="me.photo_profile = null"
                                                class="btn btn-rounded btn-danger" 
                                                title="Delete"
                                                type="button">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <label for="file-upload" class="pointer">
                                            <img src="/img/no-profile.png" alt="" class="img-fluid">
                                        </label>
                                        <input id="file-upload" class="input-file-avatar d-none" type="file" @change="upload($event)">
                                    </div>
                                </div>
                                <ValidationProvider name="Nama" v-slot="{ errors }" rules="required">
                                    <div class="form-group">
                                        <label for="">Nama</label>
                                        <input type="text" class="form-control" v-model="me.name">
                                        <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider name="Nama perusahaan" v-slot="{ errors }" rules="required">
                                    <div class="form-group">
                                        <label for="">Nama Perusahaan</label>
                                        <input type="text" class="form-control" v-model="me.corporate_name">
                                        <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider name="No telepon" v-slot="{ errors }" rules="required|min:8|numeric">
                                    <div class="form-group">
                                        <label for="">No. Telepon</label>
                                        <input type="text" class="form-control" v-model="me.phone_number">
                                        <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider name="Email" v-slot="{ errors }" rules="required">
                                    <div class="form-group">
                                        <label for="">Email</label>
                                        <input type="text" class="form-control" disabled v-model="me.email">
                                        <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                    </div>
                                </ValidationProvider>
                                <div class="col text-center">
                                    <button type="submit" class="btn btn-primary f-14 mt-4">Ubah</button>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
                <div class="tab-pane fade" id="alamat" role="tabpanel" aria-labelledby="alamat-tab">
                    <div class="mt-4">
                        <p class="f-14 font-bold">List Alamat 
                            <span class="float-right text-primary font-normal pointer" data-toggle="modal" data-target="#addAddress" @click="reset_form()">Tambah Alamat</span>
                        </p>
                        <div class="card mb-3 active-order" v-for="address in addresses" :key="address.id">
                            <div class="card-body">
                                <div class="float-right"><img src="/img/dot.png" alt="" class=""></div>
                                <p class="mb-1 f-14"><b>{{ address.name }} - {{ address.phone_number }}</b></p>
                                <p class="text-secondary f-14">
                                    {{ address.address }},
                                    {{ address.location.kabupaten }},
                                    {{ address.location.provinsi }},
                                    {{ address.zipcode.kodepos }}
                                </p>
                                <hr>
                                <button class="btn btn-primary btn-sm p-1 float-right" @click="destroy_address(address)">Hapus Alamat</button>
                                <span class="f-14 text-primary pointer" data-toggle="modal" data-target="#addAddress" 
                                    @click="
                                        model.pengirim = address,
                                        model.pengirim.province = locations.filter(x => x.id == address.id_location).map( z => z.provinsi )[0],
                                        get_kode_pos('pengirim', address.id_location),
                                        get_marker(address.lat, address.lng)
                                    ">
                                    Ubah Alamat
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade pt-4" id="password" role="tabpanel" aria-labelledby="password-tab">
                    <div class="mx-auto mt-4 col-lg-6">
                        <ValidationObserver ref="change_password" tag="form" onsubmit="return false;">
                            <ValidationProvider name="Kata sandi lama" rules="required|min:8|alpha_num">
                                <div class="form-group" slot-scope="{ errors }">
                                    <label class="form-label">Kata sandi lama</label>
                                    <div class="input-group" id="show_hide_password_old" :class="{ 'error': errors[0] }">
                                        <input type="password" class="form-control append-button" placeholder="Masukkan kata sandi lama" v-model="credential.old_password">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="text-danger f-12 mt-2">{{ errors[0] }}</div>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider name="Kata sandi baru" rules="required|min:8|alpha_num">
                                <div class="form-group" slot-scope="{ errors }">
                                    <label class="form-label">Kata sandi baru</label>
                                    <div class="input-group" id="show_hide_password" :class="{ 'error': errors[0] }">
                                        <input type="password" class="form-control append-button" placeholder="Masukkan kata sandi baru" v-model="credential.new_password">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="text-danger f-12 mt-2">{{ errors[0] }}</div>
                                </div>
                            </ValidationProvider>

                            <ValidationProvider name="Konfirmasi kata sandi" rules="required|confirmed:Kata sandi baru">
                                <div class="form-group" slot-scope="{ errors }">
                                    <label class="form-label">Ulangi kata sandi</label>
                                    <div class="input-group" id="show_hide_password_confirm" :class="{ 'error': errors[0] }">
                                        <input type="password" class="form-control append-button" placeholder="Ulangi kata sandi baru" v-model="credential.conf_new_password">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="text-danger f-12 mt-2">{{ errors[0] }}</div>
                                </div>
                            </ValidationProvider>
                            <div class="text-center">
                                <button class="btn btn-primary f-14 mt-4 w-100" @click="change_password()">Simpan</button>
                            </div>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="addAddress">
		    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		        <div class="modal-content mx-auto">                           
                    <ValidationObserver ref="alamat">
                        <form @submit.prevent="store_address()">
                            <div class="modal-body">                
                                <p class="f-14 f-m-12"><b>{{ model.pengirim.id ? 'Ubah' : 'Tambah'}} Alamat</b>   
                                    <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </p>
                                <div class="row">
                                    <div class="col-6">
                                        <ValidationProvider name="Nama" v-slot="{ errors }" rules="required">
                                            <div class="form-group">
                                                <label for="">Nama</label>
                                                <input type="text" class="form-control" v-model="model.pengirim.name" placeholder="Masukkan nama">
                                                <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6">
                                        <ValidationProvider name="No. telepon" v-slot="{ errors }" rules="required|min:8|alpha_num">
                                            <div class="form-group">
                                                <label for="">No. Telepon</label>
                                                <input type="number" class="form-control" v-model="model.pengirim.phone_number" placeholder="Masukkan nomor telepon">
                                                <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6">
                                        <ValidationProvider name="Provinsi" v-slot="{ errors }" rules="required">
                                            <div class="form-group">
                                                <label for="">Provinsi</label>
                                                <multiselect 
                                                    open-direction="bottom"
                                                    v-model="model.pengirim.province" 
                                                    placeholder="Pilih Provinsi" 
                                                    :options="locations.map(x => x.provinsi).reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]).sort()" 
                                                    :multiple="false"  
                                                    @input="selectedCityPengirim = null, model.pengirim.id_location = '', model.pengirim.id_kodepos = '', $forceUpdate()"/>
                                                <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-6">
                                                <ValidationProvider name="Kota / kabupaten" v-slot="{ errors }" rules="required">
                                                    <div class="form-group">
                                                        <label for="">Kota / Kabupaten</label>
                                                        <multiselect 
                                                            open-direction="bottom"     
                                                            v-model="selectedCityPengirim" 
                                                            placeholder="Pilih Kota / Kabupaten" 
                                                            track-by="id"
                                                            label="kabupaten"
                                                            :options="locations.filter(x => x.provinsi == model.pengirim.province)" 
                                                            :multiple="false" 
                                                            @input="model.pengirim.id_location = selectedCityPengirim.id, get_kode_pos('pengirim', model.pengirim.id_location)"/>
                                                        <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                            <div class="col-6">
                                                <ValidationProvider name="Kode pos" v-slot="{ errors }" rules="required">
                                                    <div class="form-group">
                                                        <label for="">Kode Pos</label>
                                                        <select v-model="model.pengirim.id_kodepos" class="form-control">
                                                            <option value="">Pilih Kode Pos</option>
                                                            <option :value="zip_code.id" v-for="zip_code in zip_codes.pengirim" :key="zip_code.id">
                                                                {{zip_code.kodepos}}
                                                            </option>
                                                        </select>
                                                        <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <ValidationProvider name="Alamat lengkap" v-slot="{ errors }" rules="required">
                                            <div class="form-group">
                                                <label for="">Alamat Lengkap</label>
                                                <textarea class="form-control" v-model="model.pengirim.address" placeholder="Masukkan alamat lengkap" cols="30" rows="5"></textarea>
                                                <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="form-label mt-2">
                                                Kordinat lokasi (opsional) 
                                                <a data-toggle="modal" href="#pilihKordinatPengirim" class="link"> Pilih Kordinat</a>
                                            </label>								
                                            <GmapMap
                                                class = "maps mb-2"
                                                style = "height: 150px"
                                                :center = map.pengirim.center
                                                :options = map.options
                                                :zoom = map.pengirim.zoom
                                                @click="set_marker('pengirim', $event)">
                                                <gmap-marker
                                                    v-for="(item, index) in map.pengirim.markers"
                                                    :key="index"
                                                    :position="item"/>
                                            </GmapMap>
                                            <p class="f-14">
                                                <b>{{ map.pengirim.address }} </b>
                                                <a href="javascript:;" class="link float-right" @click="delete_kordinat('pengirim')" v-if="model.pengirim.lat != ''">Hapus Kordinat</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <button type="submit" class="btn btn-primary">Simpan</button>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
		        </div>
		    </div>
		</div>

        <div class="modal fade" id="pilihKordinatPengirim">
		    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		        <div class="modal-content mx-auto">                           
		            <div class="modal-body">                
		                <p class="f-14 f-m-12"><b>Pilih Kordinat</b>   
		                <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                </p>
		                <div class="mt-2 f-14" style="background-color: #ffe8cf; border-radius: 4px; padding:20px 20px;">
		                    Pastikan lokasi yang kamu pilih tidak berbeda jauh dengan alamat yang kamu isi di kolom alamat.
		                </div>		                
						<gmap-autocomplete
                            @place_changed="set_kordinat('pengirim', $event)"
                            placeholder="Masukkan alamat"
                            class="form-control"
                            ref="mapp">
						</gmap-autocomplete>
						<GmapMap
                            class = "maps mb-2"
                            style = "height: 330px"
                            :center = map.pengirim.center
                            :options = map.options 
                            :zoom = map.pengirim.zoom							
                            @click="set_marker('pengirim', $event)">
							<gmap-marker
                                v-for="(item, index) in map.pengirim.markers"
                                :key="index"
                                :position="item"/>
						</GmapMap>
						<p class="f-14"><b>{{ map.pengirim.address }} </b></p>
                        <div class="text-right">
		                    <button type="button" class="btn btn-primary" data-dismiss="modal">Simpan</button>
                        </div>
		            </div>
		        </div>
		    </div>
		</div>
	</section>
</template>
<script>
import Vue from "vue"
export default {
	data() {
		return {
            locations: [],
            addresses: [],
            zip_codes: {
                pengirim: [],
                penerima: []
            },
			map: {
                pengirim: {
                    address: '',
                    place: '',
                    markers: [],
                    lat: '',
                    lng: '',
                    zoom: 4,
                    center: { lat:-2.2145852388265177, lng:117.104081069627 }
                },
                options: {
                    streetViewControl: false,
                    fullscreenControl: false,
                    mapTypeControl: false,
                },
			},
            model: {
                pengirim: {
                    name: '',
                    phone_number: '',
                    province: '',
                    id_location: '',
                    id_kodepos: '',
                    address: '',
                    lat: '',
                    lng: ''
                }
            },
            me: {
                name: '',
                photo_profile: null,
                phone_number: '',
                email: ''
            },
            credential: {
                old_password: '',
                new_password: '',
                conf_new_password: ''
            },
            selectedCityPengirim: null
        }
	},
    methods: {
        get_location()
        {
			let _ = this
			_.axios.get('/location')
				.then(resp => {
                    _.locations = resp.data.data.rows
				}).catch(err => {
					console.log(err.response)
				})
		},
        get_kode_pos(type, id_location)
        {
			let _ = this			
			_.axios.get('/location?id=' + id_location )
				.then(resp => {
                    _.zip_codes[type] = resp.data.data.rows.kodepos
                    _.$forceUpdate()
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})			
		},
        set_kordinat(type, place)
        {
		    let _ = this
            let latLng = {
                lat: parseFloat(place.geometry.location.lat()),
                lng: parseFloat(place.geometry.location.lng()),
            }

            _.map[type].place 	= place
            _.map[type].markers = [latLng]
            _.map[type].center 	= latLng
            _.map[type].zoom 	= 18

            Vue.$geocoder.send(latLng,
                response => {
                    _.map[type].address = response.results[0].formatted_address
                })
            
            _.model[type].lat = parseFloat(place.geometry.location.lat())
            _.model[type].lng = parseFloat(place.geometry.location.lng())
            _.$forceUpdate()
		},
        delete_kordinat(type) {
            let _ 					= this
            _.map[type].markers 	= []
			_.map[type].address 	= ''
            _.map[type].zoom        = 4,
            _.map[type].center      = { lat:-2.2145852388265177, lng:117.104081069627 }
			_.model[type].lat		= ''
			_.model[type].lng		= ''
            this.$refs.mapp.$el.value = '';
            _.$forceUpdate()
        },	
        set_marker(type, place) 
        {
		    let _ = this

			_.model[type].markers = [{
                lat: parseFloat(place.latLng.lat()),
                lng: parseFloat(place.latLng.lng()),
			}]

            Vue.$geocoder.send({
                lat: parseFloat(place.latLng.lat()),
                lng: parseFloat(place.latLng.lng()),
            },
            response => {
                _.map[type].address = response.results[0].formatted_address
            })
			
			_.model[type].lat = parseFloat(place.latLng.lat())
			_.model[type].lng = parseFloat(place.latLng.lng())
            _.$forceUpdate()
		},
        get_marker(lat, lng) {
            let _ = this
            _.model.pengirim.markers = [{
                lat: parseFloat(lat),
                lng: parseFloat(lng),
			}]

            Vue.$geocoder.send({
                lat: parseFloat(lat),
                lng: parseFloat(lng),
            },
            response => {
                _.map.pengirim.address = response.results[0].formatted_address
            })
			
			_.model.pengirim.lat = parseFloat(lat)
			_.model.pengirim.lng = parseFloat(lng)
            _.$forceUpdate()
        },
        get_addresses() 
        {
            let _ = this
            _.axios.get('/address')
                .then(resp => {
                    _.addresses = resp.data.data
                })
                .catch(err => {
                    console.log(err.data.response.message)
                })
        },
        async store_address()
        {
            let _ = this
            const isValid = await this.$refs.alamat.validate();
            if (!isValid) { 
                return;
            }
            if (_.model.pengirim.id) {
                _.update_address()
                return;
            }
            _.axios.post('/address', _.model.pengirim)
                .then(resp => {
                    console.log(resp.data.data)
                    _.get_addresses()
                    $('#addAddress').hide()
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();

                    this.$toast.open({
						message: 'Alamat baru berhasil ditambahkan',
						type: "success"
					})
                })
        },
        update_address()
        {
            let _ = this
            _.axios.patch('/address/' + _.model.pengirim.id, _.model.pengirim)
                .then(resp => {
                    console.log(resp.data.data)
                    _.get_addresses()
                    $('#addAddress').hide()
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();

                    this.$toast.open({
						message: 'Alamat berhasil dibuah',
						type: "success"
					})
                })
        },
        destroy_address( address )
        {
            let _ = this
            _.axios.delete('/address/' + address.id)
                .then(resp => {
                    console.log(resp.data.data)
                    _.get_addresses()

                    this.$toast.open({
						message: 'Alamat berhasil dihapus',
						type: "success"
					})
                })
        },
        reset_form()
        {
            let _ = this
            _.selectedCityPengirim = null
            _.model = {
                pengirim: {
                    name: '',
                    phone_number: '',
                    province: '',
                    id_location: '',
                    id_kodepos: '',
                    address: '',
                    lat: '',
                    lng: ''
                }
            }
            _.$refs.alamat.reset()
            this.delete_kordinat('pengirim')
        },
        upload(event){
            let _ = this
            let file = event.target.files[0]
            let formData = new FormData()
            formData.append('file', file)

            _.axios.post('/misc/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' }})
                .then(resp => {
                    _.me.photo_profile = resp.data.data.url
                })
                .catch(err => {
                    console.log(err.response.data)
                    _.isLoading = false
                })
        },
        get_me() {
            let _ = this
            _.axios.get('/auth/me')
                .then(resp => {
                    _.me = resp.data
                    _.$root.$emit('change_profile', _.me.photo_profile)
                    _.$root.$emit('change_user', _.me)
                })
        },
        async update_profile()
        {
            let _ = this
            const isValid = await this.$refs.profil.validate();
            if (!isValid) { 
                return;
            }
            _.axios.patch('/user/' + _.me.id, _.me)
                .then( resp => {
                    console.log(resp.data)
                    this.$toast.open({
						message: 'Profil berhasil diubah',
						type: "success"
					})
                    _.get_me()
                })
        },
        async change_password()
        {
            let _ = this
            const isValid = await this.$refs.change_password.validate();
            if (!isValid) { 
                return;
            }
            _.axios.post('/auth/change_password', _.credential)
                .then(resp => {
                    console.log(resp.data.data)
                    this.$toast.open({
						message: 'Kata sandi berhasil diubah',
						type: "success"
					})
                })
                .catch(() => {
                    this.$toast.open({
						message: 'Kata sandi lama salah',
						type: "error"
					})
                })
        }
    },
	mounted() {
        $("#show_hide_password_old span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password_old input').attr("type") == "text"){
	            $('#show_hide_password_old input').attr('type', 'password');
	            $('#show_hide_password_old i').addClass( "fa-eye-slash" );
	            $('#show_hide_password_old i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password_old input').attr("type") == "password"){
	            $('#show_hide_password_old input').attr('type', 'text');
	            $('#show_hide_password_old i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password_old i').addClass( "fa-eye" );
	        }
	    });

		$("#show_hide_password span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password input').attr("type") == "text"){
	            $('#show_hide_password input').attr('type', 'password');
	            $('#show_hide_password i').addClass( "fa-eye-slash" );
	            $('#show_hide_password i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password input').attr("type") == "password"){
	            $('#show_hide_password input').attr('type', 'text');
	            $('#show_hide_password i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password i').addClass( "fa-eye" );
	        }
	    });

	    $("#show_hide_password_confirm span").on('click', function(event) {
	        event.preventDefault();
	        if($('#show_hide_password_confirm input').attr("type") == "text"){
	            $('#show_hide_password_confirm input').attr('type', 'password');
	            $('#show_hide_password_confirm i').addClass( "fa-eye-slash" );
	            $('#show_hide_password_confirm i').removeClass( "fa-eye" );
	        }else if($('#show_hide_password_confirm input').attr("type") == "password"){
	            $('#show_hide_password_confirm input').attr('type', 'text');
	            $('#show_hide_password_confirm i').removeClass( "fa-eye-slash" );
	            $('#show_hide_password_confirm i').addClass( "fa-eye" );
	        }
	    });

        let _ = this
        _.get_location()
        _.get_addresses()
        _.get_me()
    }
}
</script>